import React, { ChangeEvent, useState } from 'react'
import { InputProps } from './Input.types'
import styles from './Input.module.scss'
import cl from 'classnames'

const InputComponent = (props: InputProps) => {
  const {
    className,
    style,
    onChange,
    size,
    onFocus: onFocusProp,
    onBlur: onBlurProp,
    onKeyDown,
    onEnterKey,
    onEscKey,
    error,
    ...rest
  } = props

  const [focused, setFocused] = useState<boolean>(false)

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e.target.value)
  }

  const onFocus = (e) => {
    setFocused(true)
    onFocusProp && onFocusProp(e)
  }
  const onBlur = (e) => {
    setFocused(false)
    onBlurProp && onBlurProp(e)
  }

  return (
    <input
      className={cl(styles.input, styles[size], {
        [styles.error]: error,
        [styles.inputFocused]: focused
      }, className)}
      style={style}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={handleOnChange}
      {...rest}
      onKeyDown={e => {
        onKeyDown && onKeyDown(e);

        (e.which === 13 && onEnterKey) && onEnterKey();
        (e.which === 27 && onEscKey) && onEscKey()
      }}
    />
  )
}

const Input = InputComponent
export { Input }
